module.exports = __webpack_public_path__ + "img/9788954614726.be9d5745.jpg";